import {AbstractStatefulView} from "../../../admin/script/views/abstract-views.js";
import {Paths} from "../../util/url.js";
import {showErrorPopup} from "../../../admin/script/util/errors.js";
import {httpGet} from "../../util/http.js";
import {LitRenderer} from "../../../admin/script/views/abstract-view.js";
import {initTooltips} from "../js/polkurier-tooltip.js";

export class AbstractStatisticsView extends AbstractStatefulView {

    fetchDataDelay = 0;

    constructor({paths, ...props}) {
        super(props);
        this.state = {
            isRequested: false,
            isFetched: false,
        };
        this.paths = Paths.factory(paths);
    }

    getDefaultRenderer() {
        return new LitRenderer();
    }

    firstRendered() {
        initTooltips(this.$el.find('[title]'));
        setTimeout(() => {
            this.fetchData().then();
        }, this.fetchDataDelay);
    }

    templateContext() {
        return {
            ...this.state,
            paths: this.paths,
        };
    }

    getUrl() {
        return '';
    }

    prepareData(rawData) {
        return rawData;
    }

    async fetchData() {
        this.setState({isRequested: true});
        try {
            this.setState({
                isFetched: true,
                ...this.prepareData(await httpGet(this.getUrl())),
            });
        } catch (e) {
            showErrorPopup(e);
        }
        this.setState({isRequested: false});
    }

}
